import { absolutePath } from "./absolutePath";

export const emailHub = {
  onboarding: {
    check: () => absolutePath("email_hub/onboarding"),
    getPopularWorkflowTemplates: () =>
      absolutePath("email_hub/onboarding/popular_workflow_templates"),
    getRecentlyUpdated: () =>
      absolutePath("email_hub/onboarding/recently_updated_resources?limit=4"),
    updateChecklist: () => absolutePath("email_hub/onboarding"),
  },
};
